var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWomenS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 378,
    height: 500,
    viewBox: "0 0 378 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 377.5,
    height: 500,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 377.5,
    height: 500,
    fill: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204.286 129.428C198.55 104.332 225.749 85.0742 253.761 98.2947C319.727 129.428 281.448 176.034 257.786 171.015C234.124 165.996 210.022 154.523 204.286 129.428Z",
    fill: "url(#paint0_linear_6148_5041)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M220.255 287.602C189.448 302.403 184.953 301.61 117.004 246.015C14.4701 162.124 111.268 85.4024 215.236 126.273C327.808 175.747 290.094 254.056 220.255 287.602Z",
    fill: "url(#paint1_linear_6148_5041)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M223.125 346.399C212.609 369.343 199.224 380.816 188.708 380.816C178.192 380.816 164.807 369.343 154.291 346.399V317.718C154.291 317.718 149.612 317.861 146.404 317.718C112.86 316.284 101.651 262.325 106.916 208.355C110.771 168.83 144.253 223.071 198.746 185.069C196.595 226.656 214.521 222.354 222.408 217.335C258.259 200.843 258.976 268.243 223.542 263.02C223.551 263.738 223.412 291.53 223.125 346.399Z",
    fill: "url(#paint2_linear_6148_5041)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M154.29 317.716C167.196 316.76 183.274 309.542 202.522 296.062C196.624 316.375 180.546 328.373 154.29 332.056V317.716Z",
    fill: "#FF9768"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M142.433 354.74C142.433 354.74 144.597 339.801 149.67 338.522C154.744 337.243 184.397 337.088 184.423 342.824C184.423 343.877 185.444 355.157 188.825 355.157C192.207 355.157 193.076 343.871 193.082 342.824C193.109 337.088 222.59 337.309 227.834 338.522C233.078 339.735 235.05 354.759 235.05 354.759C235.05 354.759 312.488 391.222 320.638 406.787C327.649 420.171 332.907 451.242 336.413 500H41C44.5058 451.242 49.7639 420.171 56.7745 406.787C64.9241 391.229 142.433 354.74 142.433 354.74Z",
    fill: "url(#paint3_linear_6148_5041)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M182.97 452.517C182.97 451.383 183.307 450.274 183.937 449.33C184.567 448.387 185.463 447.652 186.511 447.218C187.56 446.784 188.713 446.67 189.826 446.891C190.938 447.113 191.96 447.659 192.763 448.461C193.565 449.263 194.111 450.285 194.333 451.398C194.554 452.511 194.44 453.664 194.006 454.712C193.572 455.761 192.837 456.656 191.893 457.287C190.95 457.917 189.841 458.253 188.707 458.253C187.185 458.253 185.726 457.649 184.651 456.573C183.575 455.498 182.97 454.039 182.97 452.517ZM182.97 423.836C182.97 422.702 183.307 421.593 183.937 420.65C184.567 419.706 185.463 418.971 186.511 418.537C187.56 418.103 188.713 417.989 189.826 418.21C190.938 418.432 191.96 418.978 192.763 419.78C193.565 420.583 194.111 421.605 194.333 422.717C194.554 423.83 194.44 424.983 194.006 426.032C193.572 427.08 192.837 427.976 191.893 428.606C190.95 429.236 189.841 429.573 188.707 429.573C187.185 429.573 185.726 428.968 184.651 427.893C183.575 426.817 182.97 425.358 182.97 423.836ZM182.97 395.156C182.97 394.021 183.307 392.912 183.937 391.969C184.567 391.025 185.463 390.29 186.511 389.856C187.56 389.422 188.713 389.308 189.826 389.53C190.938 389.751 191.96 390.297 192.763 391.1C193.565 391.902 194.111 392.924 194.333 394.037C194.554 395.149 194.44 396.303 194.006 397.351C193.572 398.399 192.837 399.295 191.893 399.925C190.95 400.555 189.841 400.892 188.707 400.892C187.185 400.892 185.726 400.287 184.651 399.212C183.575 398.136 182.97 396.677 182.97 395.156Z",
    fill: "#664F4D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M203.892 172.059C180.948 229.421 193.854 257.385 211.78 291.085C229.705 324.785 207.478 356.334 207.478 356.334C207.478 356.334 233.29 339.842 233.29 303.274C233.29 266.706 207.478 243.761 228.988 213.646C250.499 183.532 226.837 114.698 203.892 172.059Z",
    fill: "url(#paint4_linear_6148_5041)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6148_5041",
    x1: 247.019,
    y1: 94,
    x2: 247.019,
    y2: 171.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D0024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#100014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6148_5041",
    x1: 180.022,
    y1: 114.954,
    x2: 180.022,
    y2: 295.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D0024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#100014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6148_5041",
    x1: 177.694,
    y1: 185.069,
    x2: 177.694,
    y2: 380.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B186"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6148_5041",
    x1: 188.706,
    y1: 500,
    x2: 188.706,
    y2: 337.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF9F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6148_5041",
    x1: 214.507,
    y1: 149.935,
    x2: 214.507,
    y2: 356.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D0024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#100014"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomenS);
export default __webpack_public_path__ + "static/media/women_s.073137d1c9f28180f262fcadb2d0dd40.svg";
export { ForwardRef as ReactComponent };